export { ScrollView, IScrollViewProps } from 'native-base';
